import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CorporateCustomerList from "./CorporateCustomerList";
import CreateCustomer from "./CreateCorporateCustomer";
import CustomerDetails from "./CorporateCustomerDetails";
import CustomerDetailsEdit from "./EditCorporateCustomer";
import CorporatecreateUserInfo from "./CorporatecreateUserInfo";
import CorporatecreateUserInfoagg from "./CorporatecreateUserInfoagg";

export default function CorporateCustomer() {
  return (
    <Switch>
      <Redirect exact={true} from="/corp-customer" to="/corp-customer/customer-list" />

      {/* Layout */}
      <Route path="/corp-customer/customer-list" component={CorporateCustomerList} />
      <Route path="/corp-customer/customer-details" component={CustomerDetails} />
      <Route path="/corp-customer/customer-create" component={CreateCustomer} />
      <Route path="/corp-customer/customer-edit" component={CustomerDetailsEdit} />
      <Route path="/corp-customer/customer-create-user" component={CorporatecreateUserInfo} />
	  <Route path="/corp-customer/customer-create-user-agg" component={CorporatecreateUserInfoagg} />
    </Switch>
  );
}
